import * as moment from 'moment';
import * as humanizeDuration from 'humanize-duration';

export const abbreviatedDurationHumanizer = humanizeDuration.humanizer({
  round: true,
  delimiter: ' ',
  language: 'abbreviatedEnglish',
  languages: {
    abbreviatedEnglish: {
      y: () => 'y',
      mo: () => 'mo',
      w: () => 'w',
      d: () => 'd',
      h: () => 'h',
      m: () => 'm',
      s: () => 's',
      ms: () => 'ms'
    }
  }
});

export function formatMinutesAsDuration(minutes: number, largest?: number): string {
  return formatDuration(moment.duration(minutes, 'm'), largest);
}

export function formatDuration(duration: moment.Duration, largest?: number): string {
  return humanizeDuration(duration.asMilliseconds(), { largest: largest, round: true });
}

export function formatAbbreviatedDuration(duration: moment.Duration, largest?: number, spacer?: string, round?: boolean): string {
  return abbreviatedDurationHumanizer(
    duration.asMilliseconds(),
    {
      largest: largest,
      spacer: spacer === undefined ? '' : spacer,
      round: round === undefined ? true : round,
    });
}